import { getCountryCode } from './get-country-code.js';
/**
 * @returns ISO 4217 alphabetic code (e.g `'EUR'`)
 */
export function getCurrency(marketId) {
    const countryCode = getCountryCode(marketId);
    return countryCode === `CH` ? `CHF` : countryCode === `GB` ? `GBP` : `EUR`;
}
//# sourceMappingURL=get-currency.js.map